export default "__VITE_ASSET__c0ccf56f__"